import React, { useCallback, useEffect, useState } from "react";

import { FiDownload } from "react-icons/fi";
import InfiniteScroll from "react-infinite-scroll-component";
import Select from "react-select";
import Swal from "sweetalert2";

import DatePicker from "../../../../../components/Input/DatePicker";
import InputSelectAsync, { selectStyle } from "../../../../../components/InputSelectAsync";
import LoadInfiniteScroll from "../../../../../components/LoadInfiniteScroll";
import { Loading } from "../../../../../components/Loading";
import { BrComerceApiService } from "../../../../../services/BrComerceApiService";
import store from "../../../../../store/store";
import ScrollDiv from "../../../components/ScrollDiv";
import { exportToExcel } from 'react-json-to-excel';


import { OriginEnum } from "../../../../../enums/OriginEnum";

import styles from "./styles.module.scss";
import moment from "moment";

const IntegrationReports = () => {
  const api = new BrComerceApiService();

  const { auth } = store.getState();
  const { user } = auth;

  const [loading, setLoading] = useState(false);

  const [integrationSelected, setIntegrationSelected] = useState();
  const [periodInitialDate, setPeriodInitialDate] = useState("");
  const [periodFinalDate, setPeriodFinalDate] = useState("");
  const [integrationReport, setIntegrationReport] = useState([]);
  const [orderNumber, setOrderNumber] = useState(null);
  const [sro, setSro] = useState(null);
  const [searchClient, setSearchClient] = useState(null);

  const integrationsSelect = [
    {
      value: OriginEnum.TRAY,
      label: "Tray"
    }
  ];

  const handleGenerateReport = useCallback(
    async () => {
      setLoading(true);
      const params = {
        sro,
        orderNumber,
        fromDate: periodInitialDate ? periodInitialDate : null,
        toDate: periodFinalDate ? periodFinalDate : null,
        subUser: searchClient?.sub
      };

      try {
        const response = await api.makeHttpRequest({
          method: "GET",
          url: `/${integrationSelected?.value}/users/report`,
          params
        });

        setIntegrationReport(response.results);

      } catch (e) {
        console.log(e);
        Swal.fire({
          title: "Erro ao carregar os pedidos.",
          text: "Tente novamente dentro de instantes. Se o erro persistir, entre em contato com o suporte.",
          icon: "error"
        });
      } finally {
        setLoading(false);
      }
    },
    [
      api,
      integrationSelected?.value,
    ]
  );

  const handleOnChangeCalendarPeriod = e => {
    const inicio = e.dateStart.split("/");
    const fim = e.dateEnd.split("/");

    setPeriodInitialDate(
      new Date(Number(inicio[2]), Number(inicio[1] - 1), Number(inicio[0]))
    );
    setPeriodFinalDate(
      new Date(Number(fim[2]), Number(fim[1] - 1), Number(fim[0]))
    );
  };

  const handleClearPeriodFilter = () => {
    setPeriodInitialDate("");
    setPeriodFinalDate("");
  };

  useEffect(() => {
    window.setPageTitle("Integrações | Relatório");
  }, []);

  return (
    <>
      <Loading loading={loading} />
      <div className={styles.container}>
        <h1 className={styles.title}>Relatórios dos pedidos</h1>

        <div className={styles.filtersWrapper}>
          {user.profile === "admin" && <div className={styles.filterInput}>
            <InputSelectAsync
              search={searchClient}
              setSearch={setSearchClient}
            />
          </div>}
          <div className={styles.filterInput}>
            <Select
              options={integrationsSelect}
              value={integrationSelected}
              isClearable
              placeholder="Selecionar integração"
              styles={selectStyle}
              onChange={setIntegrationSelected}
            />
          </div>
          <div className={`${styles.filterInput} ${styles.filterDateInput}`}>
            <DatePicker
              className={"datePickerConfig"}
              change={handleOnChangeCalendarPeriod}
              placeholder="Filtrar por periodo"
              showClearButton={!!periodInitialDate && !!periodFinalDate}
              onClearFields={handleClearPeriodFilter}
              range
            />
          </div>

          <div className={styles.buttonReport}>
            <button
              type="button"
              onClick={() => handleGenerateReport()}
              className={`${(!integrationSelected?.value || !periodInitialDate || !periodFinalDate) ? styles.disabled : styles.buttonImport}`}
              disabled={!integrationSelected?.value || !periodInitialDate || !periodFinalDate}
            >
              <p>
                Gerar relatório
              </p>
            </button>
          </div>
          <div className={styles.buttonDownload}>
            <button
              type="button"
              onClick={() => exportToExcel(
                integrationReport,
                `Relatório ${integrationSelected?.label}${periodInitialDate && periodFinalDate && ` (${moment(periodInitialDate).format("DD-MM-YYYY")} - ${moment(periodFinalDate).format("DD-MM-YYYY")})`}`)
              }
              className={`${!integrationReport?.length ? styles.disabled : styles.buttonImport}`}
              disabled={!integrationReport?.length}
            >
              <FiDownload />
              <p>
                Baixar relatório
              </p>
            </button>
          </div>
        </div>

        <div className={styles.tableContainer}>
          <ScrollDiv data={integrationReport}>
            <InfiniteScroll
              dataLength={integrationReport?.length}
              next={() => { }}
              hasMore={false}
              loader={
                <>
                  <span>Gerando relatório...</span>
                  <LoadInfiniteScroll />
                </>
              }
              scrollableTarget="scrollDiv"
              className={styles.infiniteScroll}
            >
              <table className={styles.table}>
                <thead className={styles.tableHead}>
                  <tr>
                    <th>Etiqueta</th>
                    <th>Número do pedido</th>
                    <th>Cliente</th>
                    <th>Data do pedido</th>
                  </tr>
                </thead>
                <tbody className={styles.tableBody}>
                  {integrationReport.map((order, i) => {
                    return (
                      <tr key={i} style={styles.row}                      >
                        <td>{order.Etiqueta}</td>
                        <td>{order.Numero}</td>
                        <td>{order.Cliente}</td>
                        <td>{order.Data}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </InfiniteScroll>
          </ScrollDiv>
        </div>
      </div>
    </>
  );
};

export { IntegrationReports };
